import { useQuery } from "@tanstack/react-query";
import { getTranscript } from "../services/api";

function useSession(sessionId: string) {
  const query = useQuery({
    queryKey: ["transcript", sessionId], // Consistent with other hooks
    queryFn: () => getTranscript(sessionId),
    enabled: !!sessionId, // Only fetch when sessionId exists
    staleTime: 1000 * 60 * 5, // Consider data fresh for 5 minutes
    gcTime: 1000 * 60 * 30, // Keep in cache for 30 minutes
  });
  return { ...query };
}

export default useSession;
